export default __webpack_public_path__ + "images/FKK.27b6cba.png";